(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("Atom", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["Atom"] = factory(require("vue"));
	else
		root["Atom"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_24__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition